// @ts-nocheck
import React, { createContext, useContext } from 'react';
import { useCarriers } from '@/hooks/query';

const CarriersContext = createContext();

function CarriersProvider({ ...props }) {
  // Fetches the carriers list.
  const { data: carriers, isLoading: isCarriersLoading } = useCarriers();

  const state = {
    carriers,
    isCarriersLoading,
  };

  return <CarriersContext.Provider value={state} {...props} />;
}

const useCarriersContext = () => useContext(CarriersContext);

export { CarriersProvider, useCarriersContext };